export default Object.freeze({
  NONE: 0,
  CHOOSE_FILE: 1,
  WHICH_STATUS: 2,
  FILE_TYPE: 3,
  ASK_FOR_ACK: 4,
  WHICH_GROUPS: 5,
  CONFIRM_GROUPS: 6,
  ASK_REPEAT: 7,
  ACTIVE_REPEAT: 8,
  TIMES_REPEAT: 9,
  REPEAT_FREQUENCY: 10,
  WHICH_REPORT: 11,
  WHICH_ABORT: 12,
  DELETE_FILE: 13,
  SEND_USER_FILE: 14,
  SEND_ASK_FOR_ACK: 15,
  OVERWRITE_CHECK: 16,
  WHICH_MAP: 17,
  CHECK_QUEUE: 18,
  SEND_CHECK_QUEUE: 19,
  ASK_DM_RECIPIENT: 20,
  SELECT_RECIPIENTS: 21,
  CREATE_MESSAGE: 22,
})
